import type { User } from '@repo-level/core-front';
import { ABTestingStore } from './abTestStorage';
import type { AssignABTestVersionParams } from './assignABTestVersion';
import { getCmsScaledVersion } from './getCmsScaledVersion';

export const checkAbTestVersion = ({
  user,
  experiment,
  cmsABTests,
  versions,
}: AssignABTestVersionParams) => {
  if (typeof window === 'undefined') return;

  const versionsNames = versions.map(({ name }) => name);

  const scaledVersion = getCmsScaledVersion(
    experiment,
    versionsNames,
    cmsABTests
  );
  if (scaledVersion) return scaledVersion;

  const userGroupVersion = checkUserGroupsABVersion(versionsNames, user);
  const lsVersion = checkLocalStorageABVersion(versionsNames, experiment);

  if (userGroupVersion) return userGroupVersion;
  if (lsVersion) return lsVersion;
};

const checkUserGroupsABVersion = (versionsNames: string[], user?: User) => {
  if (!user?.statuses) return;

  const userGroupVersion = user?.statuses.find((status) =>
    versionsNames.find((name) => name === status.id)
  );

  return userGroupVersion?.id;
};

const checkLocalStorageABVersion = (
  versionsNames: string[],
  experiment: string
) => {
  const localStorageVersion = ABTestingStore(experiment).get()?.name;

  const savedExperiment = versionsNames.find(
    (name) => name === localStorageVersion
  );

  return savedExperiment;
};
